import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import Icon from "@mdi/react";
import clsx from "clsx";

import { AVAILABLE_NAV_LIST_BY_ACCOUNT_TYPE, MOBILE_NAV_ITEMS } from "constants/navigation";
import { routes } from "constants/routes";
import { useUserFeature } from "hooks/useUserFeature";
import styles from "./style.module.scss";

export default function MobileNavigationBar() {
  const { isShipper, isInvitedCarrier, isCarrierTrial, isBrokerTrial, isDispatcher } =
    useUserFeature();

  const AVAILABLE_NAV_LIST = useMemo(() => {
    if (isShipper) {
      return AVAILABLE_NAV_LIST_BY_ACCOUNT_TYPE["shipper"];
    } else if (isDispatcher) {
      return AVAILABLE_NAV_LIST_BY_ACCOUNT_TYPE["dispatcher"];
    } else return AVAILABLE_NAV_LIST_BY_ACCOUNT_TYPE["default"];
  }, [isShipper, isDispatcher]);

  return (
    <div className={styles.navigationWrapper}>
      <div className={styles.navigationBackdrop}></div>

      <nav className={styles.navigationBar}>
        {MOBILE_NAV_ITEMS.filter((nav_item) => AVAILABLE_NAV_LIST.includes(nav_item.title)).map(
          ({ icon, title, link }) => (
            <NavLink
              key={link}
              to={
                title === "haulpay" && !isInvitedCarrier && (isCarrierTrial || isBrokerTrial)
                  ? routes.HAULPAY_STATUS
                  : link
              }
              className={({ isActive }) =>
                clsx(styles.navigationItem, isActive ? "text-navActive" : "text-navLink")
              }>
              <Icon path={icon} className="m-auto" />
            </NavLink>
          )
        )}
      </nav>
    </div>
  );
}
